import styled from 'styled-components';

const IFrame = styled.iframe.attrs(props => ({
    height: props?.height || '94%'
}))`
    width: 100%;
    height: ${({ height }) => height};
    border-width: 0px;
`;

export default IFrame;
